import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSettings as fetchSettingsAPI } from '../../services/firebase';
import { normalizeSettingsFromRTDB } from '../../utils/helpers';

export const fetchSettings = createAsyncThunk(
  'settings/fetchSettings',
  async (_, { rejectWithValue }) => {
    try {
      const settings = await fetchSettingsAPI();
      return settings;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  settings: {
    siteName: 'PSH STORE',
    currency: 'USDT',
    downloadLink: '',
    universalScriptLink: '',
    downloadItems: [],
    commission: 15,
    exchangeRateINR: 92,
    pointsRate: 20,
    referralBonus: 10,
    topUpBonusPercent: 0,
    scriptRequestFee: 5,
    scriptRequestMinAmount: 5,
    extensionDiscount: {}
  },
  loading: false,
  error: null,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = normalizeSettingsFromRTDB(action.payload);
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectSettings = (state) => state.settings.settings;

export default settingsSlice.reducer;
